import { jsx as _jsx } from "react/jsx-runtime";
import { UserProfile } from 'components/userProfile';
import { useConversationRow } from '../../../utils/useConversationRow';
import styles from './conversationsTableAssignedAgent.module.scss';
/** Represents the content of the assigned agent cell in the conversations table. */
export const ConversationsTableAssignedAgent = () => {
    var _a, _b, _c;
    const { conversationAndRequester: { conversation }, } = useConversationRow();
    // TODO: Implement unassigned agent presentation
    return (_jsx(UserProfile, { user: (_b = (_a = conversation.assignment) === null || _a === void 0 ? void 0 : _a.agent) !== null && _b !== void 0 ? _b : undefined, unknownLabel: "Unassigned", nameClassName: ((_c = conversation.assignment) === null || _c === void 0 ? void 0 : _c.agent) ? undefined : styles.unassigned, truncateName: true }));
};
